// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @components
const { HireCardImageSelector } = require('components/hire/hireCardImageSelector/hireCardImageSelector');

class HireCardOpenYoungStep2 extends React.Component {

    render() {
        const { immHireCardImageSelector,immHireCardImageIds } = this.props;
                return (
            <article className="hire-card-open-young-step-two">
                <FormattedText
                    className="hire-card-open-young__step-title"
                    value="hireCardOpenYoung-hireCardOpenYoung_step2Title"
                />
                <HireCardImageSelector
                    cardImageIds={immHireCardImageIds.toJS()}
                    immHireCardImageSelector={immHireCardImageSelector}
                />
            </article>
        );
    }
}

HireCardOpenYoungStep2.propTypes = {
    immHireCardImageSelector: PropTypes.object.isRequired,
};

module.exports = HireCardOpenYoungStep2;

